import {base} from '../../../models/base';

export default {
  namespace: 'news',
  state:{},
  reducers: Object.assign(
    base,
    {
      setNews(state, {data}){
        console.info("news/data: ", data);
        return { ...state, data: data };
      },
    }),
};



// WEBPACK FOOTER //
// ./src/pages/news/models/news.js